import { render } from "./PersonalForm.vue?vue&type=template&id=05ce5f0a&scoped=true"
import script from "./PersonalForm.vue?vue&type=script&lang=js"
export * from "./PersonalForm.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=05ce5f0a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ce5f0a"]])

export default __exports__